<template>
    <div class="mt-5">
        <h3 class="mb-3 text-lg font-medium leading-6 dark:text-white">
            Serviços da Ticto
        </h3>
        <div class="grid gap-5 sm:grid-cols-4">
            <card v-for="item in services" :key="item.name" :loading="loading" class="h-full">
                <a
                    @click.prevent="
                        item.name !== 'ViewAI'
                            ? redirect(item.href)
                            : (this.show = true)
                    "
                    class="cursor-pointer flex flex-col h-full"
                >
                    <p
                        class="mb-3 font-bold uppercase text-gray-400 dark:text-gray-400"
                    >
                        {{ item.name }}
                    </p>
                    <div class="flex-1 flex items-center justify-center">
                        <img
                            :src="item.image"
                            :alt="item.name"
                            class="h-20 w-full object-contain rounded-md"
                        />
                    </div>
                </a>
            </card>
        </div>
    </div>

    <modal class="min-h-full" :open="show" @close="show = false">
        <div
            class="flex min-h-fit w-full flex-col flex-wrap space-y-3 divide-y divide-slate-500 text-gray-900 dark:text-white"
        ></div>
        <h1
            class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-gray-900 dark:text-white"
        >
            ViewAI
        </h1>

        <div class="grid gap-5 sm:grid-cols-2">
            <card class="flex">
                <a
                    @click.prevent="redirectView('users')"
                    class="flex-1 cursor-pointer"
                >
                    <p
                        class="white:text-black mb-2 font-bold uppercase dark:text-white"
                    >
                        Usuários
                    </p>
                </a>
            </card>
            <card class="flex">
                <a
                    @click.prevent="redirectView('plans')"
                    class="flex-1 cursor-pointer"
                >
                    <p class="mb-2 font-bold uppercase dark:text-gray-200">
                        Planos
                    </p>
                </a>
            </card>
        </div>
    </modal>
</template>

<script>
import ShippingImage from "../../../../public/img/shipping-provider.png";
import TictoImage from "../../../../public/img/ticto.png";
import Card from "../../components/layouts/Card.vue";
import Modal from "../../components/layouts/Modal.vue";

export default {
    components: { Card, Modal },
    data() {
        return {
            loading: false,
            show: false,
            services: [
                {
                    name: "Transfeera",
                    image: "https://transfeera.com/wp-content/themes/assets/global/layout/images/logos/transfeera-logo-branca.svg",
                    href: "transfeera",
                },
                {
                    name: "z-api",
                    image: "https://cdn.greatsoftwares.com.br/arquivos/paginas/10603-92bb9420b363835d05d41b96a45d8f4e.png",
                    href: "zapi",
                },
                {
                    name: "evolution-api",
                    image: "https://mintlify.s3-us-west-1.amazonaws.com/atendai-eb1f2775/images/brand/cover-white.png",
                    href: "evolution-api",
                },
                {
                    name: "ViewAI",
                    image: "https://i.ibb.co/tQmV0vx/smartplayer-logo.png",
                    href: "viewai.users",
                },
                {
                    name: "Transportadoras",
                    image: ShippingImage,
                    href: "shipping-providers",
                },
                {
                    name: "Iris",
                    image: TictoImage,
                    href: "iris",
                },
                {
                    name: "CRM Bonus",
                    image: TictoImage,
                    href: "crm-bonus",
                },
            ],
        };
    },
    methods: {
        redirect(href) {
            this.$router.push({
                name: `services.${href}`,
            });
        },
        redirectView(href) {
            this.$router.push({
                name: `services.viewai.${href}`,
            });
        },
    },
};
</script>
